import { PricingPlanCard, PricingPlanContainer } from "ui/data-display/PricingPlan/PricingPlanCard";
import { useGetPricingPlansQuery, useSelectPricingPlanMutation, useChangePricingPlanMutation } from "services/payments";
import { selectActiveSubscription, selectUser } from "features/users/usersSlice";
import { useAppSelector } from "app/hooks";
import { useTranslation } from "react-i18next";
import { PricingPlan } from "types";
import { Container } from "ui/layout/Containers";
import { Heading } from "ui/typography/Heading";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


export const SelectPricingPlanPage = () => {

    const { data: pricingPlans, isLoading, isError } = useGetPricingPlansQuery();
    const { t } = useTranslation();
    const activeSubscription = useAppSelector(selectActiveSubscription);
    const user = useAppSelector(selectUser);
    const [selectPricingPlan, { isLoading: isSelecting, isError: isSelectError, isSuccess }] = useSelectPricingPlanMutation();

    const navigate = useNavigate();

    useEffect(() => {
        if (isSuccess) {
            alert(t('pricingPlans:selectSuccess'));
        }
        if (isSelectError) {
            alert(t('pricingPlans:selectError'));
        }
        if (activeSubscription) {
            navigate('/pricing/update/');
        }
    }, [isSuccess, activeSubscription, isSelectError]);

    const handleSelectPlan = (planId: string) => {
        if (!user) {
            navigate('/sign-in/');
            return;
        }
        selectPricingPlan({ planId });
    };


    if (isLoading) {
        return <div>{t('pricingPlans:loading')}</div>;
    }

    if (isError || !pricingPlans) {
        return <div>{t('pricingPlans:errorLoading')}</div>;
    }

    if (activeSubscription) {
        return <div>{t('pricingPlans:alreadySubscribed')}</div>;
    }

    return (
        <Container>
            <Heading>{t('pricingPlans:title')}</Heading>
            <PricingPlanContainer>
                {pricingPlans.map((plan: PricingPlan) => (

                    <PricingPlanCard key={plan.id} plan={plan} onSelect={(id) => console.log(`Selected plan ID: ${id}`)} />
                ))}
            </PricingPlanContainer>
        </Container>
    );
};


export const UpdatePricingPlanPage = () => {
    
    const { data: pricingPlans, isLoading, isError } = useGetPricingPlansQuery();
    const [changePricingPlan, { isLoading: isChanging, isError: isChangeError, isSuccess }] = useChangePricingPlanMutation();
    const activeSubscription = useAppSelector(selectActiveSubscription);
    const user = useAppSelector(selectUser);
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isSuccess) {
            alert(t('pricingPlans:changeSuccess'));
        }
        if (!user) {
            navigate('/sign-in/');
        }
        
    }, [isSuccess, user]);

    const handleChangePlan = (planId: string) => {
        changePricingPlan({ planId });
    };

    if (isLoading) {
        return <div>{t('pricingPlans:loading')}</div>;
    }

    if (isError || !pricingPlans) {
        return <div>{t('pricingPlans:errorLoading')}</div>;
    }
    if (!activeSubscription) {
        return <div>{t('pricingPlans:notSubscribed')}</div>;
    }

    return (
        <Container>
            <Heading>{t('pricingPlans:updateTitle')}</Heading>
            <PricingPlanContainer>
                {pricingPlans.filter((plan: PricingPlan) => plan.id !== activeSubscription?.pricing_plan?.id).map((plan: PricingPlan) => (
                    <PricingPlanCard key={plan.id} plan={plan} onSelect={handleChangePlan} />
                ))}
            </PricingPlanContainer>
            {isChanging && <div>{t('pricingPlans:changingPlan')}</div>}
            {isChangeError && <div>{t('pricingPlans:errorChanging')}</div>}
        </Container>
    )
};